<mat-card class="settingsBody">
    <mat-card-header>
        <mat-card-title class="settings-heading">Client Health</mat-card-title>
        <div class="export-button-area">
            <span
                title="Download Excel"
                class="export-button"
                style="padding-left: 15px; cursor: pointer"
                (click)="exportToExcel()"
            >
                <mat-icon fontSet="fas" fontIcon="fa-file-excel"></mat-icon>
            </span>
        </div>
    </mat-card-header>
    <mat-tab-group
        *ngIf="tabs"
        #example1
        ActiveTabIndex="tab"
        (selectedTabChange)="handleTabChange($event)"
        useAutomaticActivation
        class="settings"
    >
        <mat-tab *ngFor="let t of tabs" [label]="t" class="settings"></mat-tab>
    </mat-tab-group>

    <div class="client-health-search-box-area">
        <mat-form-field fluid appearance="outline" class="example-full-width">
            <mat-label>Find Client</mat-label>
            <input
                matInput
                [(ngModel)]="searchTerms"
                class="search-field"
                (ngModelChange)="clientSearch()"
                [ngModelOptions]="{ standalone: true }"
            />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>

    <br />
    <div>
        <custom-mat-table [customTableInfo]="customTableInfo"></custom-mat-table>
    </div>
</mat-card>
